<div class="main-content side-content mt-10 ">
  <div class="main-container container-fluid">
    <div class="inner-body">
      <!-- Page Header -->
      <div class="page-header">
        <div>
          <h2 class="main-content-title tx-24 mg-b-5">Welcome To Dashboard</h2>
          <ol class="breadcrumb">
            <li class="breadcrumb-item"><a href="javascript:void(0)">Home</a></li>
            <!-- <li class="breadcrumb-item active" aria-current="page">Project Dashboard</li> -->
          </ol>
        </div>
        <!-- <div class="d-flex">
          <div class="justify-content-center">
            <button type="button" class="btn btn-white btn-icon-text my-2 me-2">
              <i class="fe fe-download me-2"></i> Import
            </button>
            <button type="button" class="btn btn-white btn-icon-text my-2 me-2">
              <i class="fe fe-filter me-2"></i> Filter
            </button>
            <button type="button" class="btn btn-primary my-2 btn-icon-text">
              <i class="fe fe-download-cloud me-2"></i> Download Report
            </button>
          </div>
        </div> -->
      </div>
      <!-- End Page Header -->
      <div class="container-fluid ">
        <div *ngIf="!NotLeft">
          <div>
            <h2 class="tx-18 mg-b-5">Your Admission Has Been Cancelled</h2>
            
          </div>
        </div>
        <div class="col-sm-12 ">
          <div class="row ">
            <div *ngIf="ShowMenu" class="col-sm-3 ">
              <div class="row ">
                <div class="col-sm-12 p-3 mb-5  card custom-card">
                  <div class="row ">
                    <label class="main-content-label tx-13 font-weight-bold mb-1">Scrutiny Status</label>
                    <div class="col-sm-9 " *ngIf="SrNo == 0  && Status == ''" > 
                      <h6 class="mt-2">Status : Scrutiny Not Available</h6> 
                    </div> 
                    <div class="col-sm-3 " *ngIf="SrNo == 0  && Status == ''"> 

                      <img alt="Logo" class="x" src="../../assets/images/scrutiny.png "> 
                    </div> 
                    <div class="col-sm-9 " *ngIf="'SrNo == 1 || SrNo == 0' && redcolor">
                      <h6 class="mt-2 redcolor">{{Status}}</h6>
                      <p class="redcolor">{{Comment}}</p>
                    </div>
                    <div class="col-sm-9 " *ngIf="'SrNo == 1 || SrNo == 0' && greenColor">
                      <!-- <label class="main-content-label tx-13 font-weight-bold mb-1">Scrutiny Status</label> -->

                      <h6 class="mt-2 greenColor">{{Status}}</h6>
                      <p class="greenColor">{{Comment}}</p>
                    </div>

                    <div class="col-sm-9 " *ngIf="'SrNo == 1 || SrNo == 0' && blackColor">
                      <!-- <label class="main-content-label tx-13 font-weight-bold mb-1">Scrutiny Status</label> -->

                      <h6 class="mt-2">{{Status}}</h6>
                      <p class="">{{Comment}}</p>
                    </div>

                    <div class="col-sm-9 " *ngIf="SrNo > 1 ">
                      <!-- <label class="main-content-label tx-13 font-weight-bold mb-1">Scrutiny Status</label> -->

                      <h6 class="mt-2">Approved</h6>
                      <!-- <p>{{Comment}}</p> -->
                    </div>
                    <div class="col-sm-3 " *ngIf="SrNo >= 1 "> 
 
                      <img alt="Logo" class="x" src="../../assets/images/scrutiny.png "> 
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="col-sm-3 ">
              <div class="row ">
                <div class="col-sm-12 p-3 mb-5 card custom-card">
                  <div class="row ">
                    <div class="col-sm-9 ">
                      <label class="main-content-label tx-13 font-weight-bold mb-1">Error</label>
                 
                      <h6>Error</h6>
                       <h6>Error</h6>
                    </div>
                    <div class="col-sm-3">
                   
                      <img class="x" alt="Logo" src="../../assets/images/clipboard.png">
                    </div>
                  </div>
                </div>
              </div>
            </div> -->
            <div *ngIf="ShowMenu" class="col-sm-3 ">
              <div class="row ">
                <div class="col-sm-12 p-3 mb-5 card custom-card">
                  <div class="row ">
                    <label class="main-content-label tx-13 font-weight-bold mb-1">Admission Fees</label>
                    <div class="col-sm-9 " *ngIf="SrNo == 0  && AdmFees == ''" >
                      <!-- <label class="main-content-label tx-13 font-weight-bold mb-1">Admission Fees</label> -->

                      <h6 class="mt-2">Total Fees : Not Available</h6>
                      
                    </div>
                    <div class="col-sm-9 " *ngIf="SrNo == 1">
                      <div *ngIf="Currency == 'INR' ">
                        <h6 class="mt-2">Total Fees :<span *ngIf="ExamFee"
                            class="currency-symbol">&#8377;</span>{{AdmFees}}</h6>
                        <p>Fees Paid :<span *ngIf="ExamFee" class="currency-symbol">&#8377;</span>{{AdmPaidFees}}</p>
                      </div>
  
                      <div *ngIf="Currency == 'USD' ">
                        <!-- <label class="main-content-label tx-13 font-weight-bold mb-1">Admission Fees</label> -->
  
                        <h6 class="mt-2">Total Fees :<span *ngIf="ExamFee" class="currency-symbolTd">$</span> {{AdmFees}}
                        </h6>
                        <p>Fees Paid :<span *ngIf="ExamFee" class="currency-symbolTd">$</span> {{AdmPaidFees}}</p>
                      </div>

                      <div *ngIf="Currency == ''">
                        <h6 class="mt-2">Total Fees : Not Available</h6>
                      </div>
                    </div>
                   
                    <div class="col-sm-9 " *ngIf="SrNo > 1">
                      <div>
                        <!-- <label class="main-content-label tx-13 font-weight-bold mb-1">Admission Fees</label> -->
                        <h6 class="mt-2">Total Fees : Paid</h6>
                        <p>Fees Paid : Paid</p>
                      </div>
                      
                    </div>
                    
                    <div class="col-sm-9 " *ngIf="SrNo == 0 && AdmFees != ''" >
                      <!-- <label class="main-content-label tx-13 font-weight-bold mb-1">Admission Fees</label> -->
 
                      <div *ngIf="Currency == 'INR' ">
                        <h6 class="mt-2">Total Fees :<span *ngIf="ExamFee"
                            class="currency-symbol">&#8377;</span>{{AdmFees}}</h6>
                        <p>Fees Paid :<span *ngIf="ExamFee" class="currency-symbol">&#8377;</span>{{AdmPaidFees}}</p>
                      </div>
 
                      <div *ngIf="Currency == 'USD' ">
                        <!-- <label class="main-content-label tx-13 font-weight-bold mb-1">Admission Fees</label> -->
 
                        <h6 class="mt-2">Total Fees :<span *ngIf="ExamFee" class="currency-symbolTd">$</span> {{AdmFees}}
                        </h6>
                        <p>Fees Paid :<span *ngIf="ExamFee" class="currency-symbolTd">$</span> {{AdmPaidFees}}</p>
                      </div>

                      <div *ngIf="Currency == ''">
                        <h6 class="mt-2">Total Fees : Not Available</h6>
                      </div>
                      
                    </div>

                    <div class="col-sm-3 ">
                      <img alt="Logo" class="x" src="../../assets/images/college.png">
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="ShowMenu" class="col-sm-3 ">
              <div class="row ">
                <div class="col-sm-12 p-3 mb-5 card custom-card">
                  <div class="row ">
                    <label class="main-content-label tx-13 font-weight-bold mb-1">Exam Fees</label>
                    <div class="col-sm-9" *ngIf="SrNo > 0">
                      <div *ngIf="ExamCurrency == 'INR' ">

                        <h6 class="mt-2">Total Fees : <span *ngIf="ExamFee" class="currency-symbol">&#8377;</span>
                          {{ExmFees}}</h6>
                        <p> Fees Paid :<span *ngIf="ExamFee" class="currency-symbol">&#8377;</span> {{ExmPaidFees}}</p>
                      </div>
                      <div *ngIf="ExamCurrency == 'USD' ">
                        <!-- <label class="main-content-label tx-13 font-weight-bold mb-1">Exam Fees</label> -->
  
                        <h6 class="mt-2"> Total Fees :<span *ngIf="ExamFee" class="currency-symbolTd">$</span> {{ExmFees}}
                        </h6>
                        <p>Fees Paid : <span *ngIf="ExamFee" class="currency-symbolTd">$</span> {{ExmPaidFees}}</p>
                      </div>
                      <div *ngIf="ExamCurrency == '' ">
  
                        <h6 class="mt-2"> Total Fees :{{ExmFees}}</h6>
                        <!-- <p>Fees Paid : <span *ngIf="ExamFee" class="currency-symbolTd">$</span> {{ExmPaidFees}}</p> -->
                      </div>
                    </div>
                    <div class="col-sm-9" *ngIf="SrNo == 0">
                      <h6 class="mt-2">Total Fees : Not Available</h6>
                    </div>

                    
                    <div class="col-sm-3 ">

                      <img alt="Logo" class="x" src="../../assets/images/fee.png">
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-sm-3 ">
              <div class="row ">
                <div class="col-sm-12 p-3 mb-5 card custom-card">
                  <div class="row ">
                    <label class="main-content-label tx-13 font-weight-bold mb-1">Student Request</label>
                   
                    <div class="col-sm-9">
                      <h6 class="mt-2">
                        {{CertType}}</h6>
                      <p> Status : {{CertStatus}}</p>
                     
                    </div>
                    <div class="col-sm-3 ">

                      <img alt="Logo" class="x" src="../../assets/images/ask-question.png">
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- <div class="row"> -->

            <div class="col-sm-12 hmar" height="200">
              <!-- <div class="row "> -->
              <div class=" p-3 mb-5 card custom-card">
                <div class="table-responsive table-container tab mt-1">
                  <table class="table table-bordered  text-left">
                    <thead>
                      <tr class="text-left">
                        <th class="f600">
                          Sr.No
                        </th>
                        <th class="f600">
                          Activity
                        </th>
                        <th class="f600">
                          Status
                        </th>
                        <th class="f600">
                          Date
                        </th>
                      </tr>
                    </thead>
                    <tbody *ngIf="(SrNo == 1 || SrNo == 0) && userType === 'new'" id="table_data">
                      <tr *ngFor="let item of tableData;">
                        <td>
                          {{item.srNo}}
                        </td>
                        <td>
                          {{item.activity}}
                        </td>
                        <td>
                          {{item.status}}
                        </td>

                        <td>{{item.AppliDate| date: 'dd/MM/yyyy'}}</td>
                      </tr>
                    </tbody>
                    <tbody *ngIf="SrNo > 1 && userType === 'new'" id="table_data">
                      <tr *ngFor="let item of tableData2;">
                        <td>
                          {{item.srNo}}
                        </td>
                        <td>
                          {{item.activity}}
                        </td>
                        <td>
                          {{item.status}}
                        </td>

                        <td>{{item.AppliDate| date: 'dd/MM/yyyy'}}</td>
                      </tr>
                    </tbody>
                    <tbody *ngIf="userType === 'old'" id="table_data">
                      <tr *ngFor="let item of tableData3;">
                        <td>
                          {{item.srNo}}
                        </td>
                        <td>
                          {{item.activity}}
                        </td>
                        <td>
                          {{item.status}}
                        </td>

                        <td>{{item.AppliDate| date: 'dd/MM/yyyy'}}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
      
    </div>
  </div>
</div>